import { useEffect, useState } from "react";

const KEY = "tickdoc_inventory_density";

/**
 * Inventory density preference.
 *
 * Default: "compact" on screens ≥1280px (Mac/PC), "comfortable" below.
 * The user's explicit choice (via toolbar toggle) wins over the default
 * and is persisted in localStorage.
 */
export default function useDensity() {
  const [density, setDensity] = useState(() => {
    if (typeof window === "undefined") return "comfortable";
    const saved = window.localStorage.getItem(KEY);
    if (saved === "compact" || saved === "comfortable") return saved;
    return window.matchMedia("(min-width: 1280px)").matches
      ? "compact"
      : "comfortable";
  });

  useEffect(() => {
    try { window.localStorage.setItem(KEY, density); } catch { /* ignore quota */ }
  }, [density]);

  return [density, setDensity];
}
